<template>

    <section id="features" aria-label="Features for running your books" class="relative overflow-hidden bg-blue-600 pt-20 pb-28 sm:py-32">
    <img src="/images/website/home-features-background.jpg" width="2245" height="1636" decoding="async" :alt="I18N.website.homepage.features.home_features.background" :title="I18N.website.homepage.features.home_features.background" class="absolute top-1/2 left-1/2 max-w-none translate-x-[-44%] translate-y-[-42%]" loading="lazy" style="color: transparent;">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
      <div class="max-w-2xl md:mx-auto md:text-center xl:max-w-none">
        <h2 class="text-3xl tracking-tight text-white sm:text-4xl md:text-5xl">
          {{ I18N.website.homepage.features.home_features.heading }}
        </h2>
        <p class="mt-6 text-lg tracking-tight text-blue-100"> {{ I18N.website.homepage.features.home_features.sub_heading }} </p>
      </div>

      <div class="mt-16 grid grid-cols-1 items-center gap-y-2 pt-10 sm:gap-y-6 md:mt-20 lg:grid-cols-12 lg:pt-0 ">
        <div class="-mx-4 flex overflow-x-auto pb-4 sm:mx-0 lg:overflow-visible sm:pb-0 lg:col-span-5">
          <div class="relative z-10 flex gap-x-3 whitespace-nowrap px-4 sm:px-0  sm:mx-auto lg:block lg:mx-0 lg:gap-y-1 lg:gap-x-0 lg:whitespace-normal">
            <div @click="toggleTab(1)" :class="{ 'bg-white lg:bg-white/10 lg:ring-1 lg:ring-inset lg:ring-white/10': activeTab === 1, 'hover:bg-white/10 lg:hover:bg-white/5': activeTab !== 1 }" class="relative rounded-full px-4 py-1 lg:rounded-r-none lg:rounded-l-xl lg:p-6">
              <h3>
                <button :class="{ 'text-blue-600': activeTab === 1, 'text-blue-100 hover:text-white': activeTab !== 1 }" class="text-lg lg:text-white" type="button" tabindex="0">
                  <span class="absolute inset-0 rounded-full lg:rounded-r-none lg:rounded-l-xl"></span>
                  {{ I18N.website.homepage.features.home_features.schedule_bookings }}
                </button>
              </h3>
              <p class="mt-2 hidden text-sm lg:block text-white">
                {{ I18N.website.homepage.features.home_features.schedule_bookings_description }}
              </p>
            </div>
            <div @click="toggleTab(2)" :class="{ 'bg-white lg:bg-white/10 lg:ring-1 lg:ring-inset lg:ring-white/10': activeTab === 2, 'hover:bg-white/10 lg:hover:bg-white/5': activeTab !== 2 }" class="relative rounded-full px-4 py-1 lg:rounded-r-none lg:rounded-l-xl lg:p-6">
              <h3>
                <button :class="{ 'text-blue-600': activeTab === 2, 'text-blue-100 hover:text-white': activeTab !== 2 }" class="text-lg lg:text-white" type="button" tabindex="-1">
                  <span class="absolute inset-0 rounded-full lg:rounded-r-none lg:rounded-l-xl"></span>
                    {{ I18N.application.events.new_event }}
                </button>
              </h3>
              <p class="mt-2 hidden text-sm lg:block text-blue-100 hover:text-white">
                {{ I18N.website.homepage.features.home_features.new_event_description }}
              </p>
            </div>
            <div @click="toggleTab(3)" :class="{ 'bg-white lg:bg-white/10 lg:ring-1 lg:ring-inset lg:ring-white/10': activeTab === 3, 'hover:bg-white/10 lg:hover:bg-white/5': activeTab !== 3 }" class="relative rounded-full px-4 py-1 lg:rounded-r-none lg:rounded-l-xl lg:p-6">
              <h3>
                <button :class="{ 'text-blue-600': activeTab === 3, 'text-blue-100 hover:text-white': activeTab !== 3 }" class="text-lg lg:text-white" type="button" tabindex="-1">
                  <span class="absolute inset-0 rounded-full lg:rounded-r-none lg:rounded-l-xl"></span>
                  {{ I18N.website.homepage.features.secondary_features.heading_2 }}
                </button>
              </h3>
              <p class="mt-2 hidden text-sm lg:block text-blue-100 hover:text-white">
                 {{ I18N.website.homepage.features.secondary_features.sub_heading_2 }} 
              </p>
            </div>
            <div @click="toggleTab(4)" :class="{ 'bg-white lg:bg-white/10 lg:ring-1 lg:ring-inset lg:ring-white/10': activeTab === 4, 'hover:bg-white/10 lg:hover:bg-white/5': activeTab !== 4 }" class="relative rounded-full px-4 py-1 lg:rounded-r-none lg:rounded-l-xl lg:p-6">
              <h3>
                <button :class="{ 'text-blue-600': activeTab === 4, 'text-blue-100 hover:text-white': activeTab !== 4 }" class="text-lg lg:text-white" type="button" tabindex="-1">
                  <span class="absolute inset-0 rounded-full lg:rounded-r-none lg:rounded-l-xl"></span>
                  {{ I18N.website.homepage.features.home_features.connected_calendar }}
                </button>
              </h3>
              <p class="mt-2 hidden text-sm lg:block text-blue-100 hover:text-white">
                {{ I18N.website.homepage.features.home_features.calendar_description }}  
              </p>
            </div>
          </div>
        </div>
        
        <div class="lg:col-span-7">
          <div role="tabpanel" tabindex="0" :class="{ 'hidden': activeTab !== 1 }">
            <div class="relative sm:px-6 lg:hidden">
              <div class="absolute -inset-x-4 top-[-6.5rem] bottom-[-4.25rem] bg-white/10 ring-1 ring-inset ring-white/10 sm:inset-x-0 sm:rounded-t-xl"></div>
              <p class="relative mx-auto max-w-2xl text-base text-white sm:text-center">
                {{ I18N.website.homepage.features.home_features.schedule_bookings_description }}  
              </p>
            </div>
            <div class="mt-10 w-[45rem] overflow-hidden rounded-xl bg-slate-50 shadow-xl shadow-blue-900/20 sm:w-auto lg:mt-0 lg:w-[67.8125rem]">
              <img :alt="I18N.website.homepage.features.home_features.schedule_bookings" 
                   :title="I18N.website.homepage.features.home_features.schedule_bookings" 
                   sizes="(min-width: 1024px) 67.8125rem, (min-width: 640px) 100vw, 45rem" 
                   :src="images.public_event" width="2174" height="1464" 
                   decoding="async" data-nimg="1" class="w-full" style="color:transparent">
            </div>
            
          </div>
          
          <div role="tabpanel" tabindex="-1" :class="{ 'hidden': activeTab !== 2 }">
            <div class="relative sm:px-6 lg:hidden">
              <div class="absolute -inset-x-4 top-[-6.5rem] bottom-[-4.25rem] bg-white/10 ring-1 ring-inset ring-white/10 sm:inset-x-0 sm:rounded-t-xl"></div>
              <p class="relative mx-auto max-w-2xl text-base text-white sm:text-center">
                {{ I18N.website.homepage.features.home_features.new_event_description }}  
              </p>
            </div>
            <div class="mt-10 w-[45rem] overflow-hidden rounded-xl bg-slate-50 shadow-xl shadow-blue-900/20 sm:w-auto lg:mt-0 lg:w-[67.8125rem]">
              <img :alt="I18N.application.events.new_event" :title="I18N.application.events.new_event"
               sizes="(min-width: 1024px) 67.8125rem, (min-width: 640px) 100vw, 45rem"
                :src="images.new_event" width="2174" height="1464" decoding="async" data-nimg="1" class="w-full" style="color:transparent">
            </div>
          </div>
          
          <div role="tabpanel" tabindex="-1" :class="{ 'hidden': activeTab !== 3 }">
            <div class="relative sm:px-6 lg:hidden">
              <div class="absolute -inset-x-4 top-[-6.5rem] bottom-[-4.25rem] bg-white/10 ring-1 ring-inset ring-white/10 sm:inset-x-0 sm:rounded-t-xl"></div>
              <p class="relative mx-auto max-w-2xl text-base text-white sm:text-center">
                {{ I18N.website.homepage.features.secondary_features.sub_heading_2 }}
              </p>
            </div>
            <div class="mt-10 w-[45rem] overflow-hidden rounded-xl bg-slate-50 shadow-xl shadow-blue-900/20 sm:w-auto lg:mt-0 lg:w-[67.8125rem]">
              <img :alt="I18N.website.homepage.features.home_features.rescheduling" 
                   :title="I18N.website.homepage.features.home_features.rescheduling" 
                   sizes="(min-width: 1024px) 67.8125rem, (min-width: 640px) 100vw, 45rem" 
                   :src="images.availability" width="2174" height="1464" decoding="async" 
                   data-nimg="1" class="w-full" style="color:transparent">
            </div>
          </div>
          
          <div role="tabpanel" tabindex="-1" :class="{ 'hidden': activeTab !== 4 }">
            <div class="relative sm:px-6 lg:hidden">
              <div class="absolute -inset-x-4 top-[-6.5rem] bottom-[-4.25rem] bg-white/10 ring-1 ring-inset ring-white/10 sm:inset-x-0 sm:rounded-t-xl"></div>
              <p class="relative mx-auto max-w-2xl text-base text-white sm:text-center">
                {{ I18N.website.homepage.features.home_features.calendar_description }}
              </p>
            </div>
            <div class="mt-10 w-[45rem] overflow-hidden rounded-xl bg-slate-50 shadow-xl shadow-blue-900/20 sm:w-auto lg:mt-0 lg:w-[67.8125rem]">
              <img :alt="I18N.website.homepage.features.home_features.connected_calendar" 
                   :title="I18N.website.homepage.features.home_features.connected_calendar" 
                   sizes="(min-width: 1024px) 67.8125rem, (min-width: 640px) 100vw, 45rem" 
                   :src="images.connected_calendar" width="2174" height="1464" decoding="async" data-nimg="1" 
                   class="w-full" style="color:transparent">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants"
export default {
  name: 'HomeFeatures',
  props: ['json_images'],
  mixins: [Constants],

  data() {
    return {
      activeTab: 1,
      images: {}
    };
  },

  methods: {
    toggleTab(tabNumber) {
      this.activeTab = tabNumber;
    }
  },
  created() {
    this.images = JSON.parse(this.json_images)
  }
}
</script>
